import instance from "./request";

//登录接口
export const AppLogin = (data) => instance.post('/sys/login', data)

//获取用户信息
export const Userinfo = () => instance.get('/sys/userinfo')
// export function Userinfo() {
//     return instance.get('/sys/userinfo')
// }



export const ProjectMenu = () => instance.get('/sys/project_menu')